<template>
  <div class="user-info">
    <div class="resume" v-if="currentUser && currentUser.roleName === 'jobseeker'" @click="goResumePage()" :class="{'matched-cur-page': $route.name === 'Resume'}">简历</div>
    <div v-if="!!currentUser" class="current-user" @mouseover="isShowUserOperate = 'inline-block'" @mouseleave="isShowUserOperate = 'none'">
      <span>
        <span class="user-icon">
          <el-avatar :size="50" :src="userIconUrl"></el-avatar>
<!--          <img :src="userIconUrl">-->
        </span>
        <span>&nbsp;</span>
        <span>{{currentUser['nickName'] || currentUser['userName']}}</span>
      </span>
      <div class="user-operate" :style="{display: isShowUserOperate}">
        <div class="op-item" @click="goMyFollowPage()" v-if="currentUser && currentUser.roleName === 'jobseeker'"><i class="el-icon-goods"></i>&nbsp;我的收藏</div>
        <div class="op-item" @click="goMyApplyPage()" v-if="currentUser && currentUser.roleName === 'jobseeker'"><i class="el-icon-sold-out"></i>&nbsp;已投简历</div>
        <div class="op-item" @click="openUserPage()" title="完善或更新个人信息"><i class="el-icon-setting"></i>&nbsp;账号设置</div>
        <div class="op-item" @click="exit()"><i class="el-icon-arrow-left"></i>&nbsp;退出登录</div>
      </div>
    </div>

    <div v-if="!currentUser" class="exit-btn" title="登录" @click="goLoginPage()">登录</div>
    <div v-if="!currentUser" class="exit-btn" title="注册" @click="goRegisterPage()">注册</div>
    <div v-if="!!currentUser" class="exit-btn" title="退出登录" @click="exit()">退出</div>
    <!--<span v-else><span class="user-op" @click="isRegister = true">注册</span>
    <span class="user-op" @click="closeDialogAndConfirm('login')">登录</span></span>
    <register-dialog :isRegister="isRegister" @closeRegisterDialog="closeDialogAndConfirm"></register-dialog>
    <login-dialog :isLogin="isLogin" @closeRegisterDialog="closeDialogAndConfirm"></login-dialog>-->
  </div>
</template>

<script>
import RegisterDialog from '../Register/RegisterDialog'
import LoginDialog from '../Login/LoginDialog'
import utilService from '../../utils/utilService'
export default {
  name: 'UserInfo',
  components: {LoginDialog, RegisterDialog},
  data () {
    return {
      isRegister: false,
      isLogin: false,
      currentUser: null,
      isShowUserOperate: 'none', // :style="{display: isShowUserOperate}"
      userIconUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
    }
  },
  methods: {
    goResumePage () {
      this.$router.push({
        name: 'Resume',
        params: null
      })
    },
    closeDialogAndConfirm (e) {
      this.isRegister = false
      this.isLogin = false
      console.log(e)
      if (e && e === 'login') {
        // this.isLogin = true
        this.$router.push({
          name: 'Login',
          params: null
        })
      }

      if (e && e === 'loginSuccess') {
        this.currentUser = this.$store.get('user') || null
      }
    },
    exit () {
      // 弹出确认框，是否退出当前用户
      setTimeout(() => {
        this.$confirm('是否退出当前用户?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          let code = this.$cookies.get('user_session')
          this.$http.post(this.$api.exitCurrentUser.url, {
            userCode: code
          }).then(res => {
            if (res && res.code === 200) {
              this.$cookies.remove('user_session')
              this.$store.clear()
              this.$store.session.clear()
              this.currentUser = null
              this.$router.push({
                name: 'Home',
                params: null
              })
            }
          })
        }).catch(() => {
        })
      })
    },
    goLoginPage () {
      this.$router.push({
        name: 'Login',
        params: null
      })
    },
    goRegisterPage () {
      this.$router.push({
        name: 'RegisterUser',
        params: null
      })
    },
    openUserPage () {
      let routeData = this.$router.resolve({
        path: '/personal-center',
        name: 'PersonalCenter'
      })
      if (this.$route.name === 'PersonalCenter') {
        // window.open(routeData.href, '_self')
        return false
      }
      window.open(routeData.href, '_blank')
    },
    goMyFollowPage () {
      this.$router.push({
        name: 'MyFollow',
        params: null
      })
    },
    goMyApplyPage () {
      this.$router.push({
        name: 'MyApply',
        params: null
      })
    }
  },
  created () {
    /**
     * 根据cookie调接口校验用户是否过期，未过期则进入首页，否则进入登录页
     * */
    if (this.$cookies.get('user_session')) {
      this.$store.set('Authorization', this.$cookies.get('user_session'))
      this.$store.session.set('Authorization', this.$cookies.get('user_session'))

      this.$http.get(this.$api.getCurrentUserInfoByCode.url, {
        userCode: this.$cookies.get('user_session')
      }).then(userInfoRes => {
        if (userInfoRes && userInfoRes.code === 200) {
          this.$store.set('user', userInfoRes.data)
          this.$store.session.set('user', userInfoRes.data)
          this.currentUser = userInfoRes.data
          utilService.currentUser = userInfoRes.data

          this.userIconUrl = userInfoRes.data.image || this.userIconUrl
        }
      })
    } else {
      if (this.$store.get('user').roleName === 'admin') {
        this.$router.push({
          name: 'NewsManage',
          params: null
        })
      } else {
        this.$router.push({
          name: 'Home',
          params: null
        })
      }
    }
  },
  mounted () {
  },
  computed: {
  }
}
</script>

<style scoped>
  .user-info {
    display: inline-block;
    /*width: 100px;*/
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    font-size: 20px;
  }
  .resume {
    display: inline-block;
    cursor: pointer;
    margin-right: 10px;
    position: relative;
  }
  .resume:hover {
    /*color: #409EFF;*/
  }

  .register-login-btn {
    border: 1px solid #409EFF;
    font-size: 14px;
    border-radius: 14px;
    padding: 2px 10px;
    cursor: pointer;
  }

  .register-login-btn:hover {
    color: #409EFF;
    /*background: #ffffff;*/
  }
  .current-user{
    position: relative;
    display: inline-block;
    cursor: pointer;
  }
  .exit-btn {
    position: relative;
    display: inline-block;
    cursor: pointer;
    font-size: 16px;
    margin-left: 5px;
  }
  .user-op {
    cursor: pointer;
    font-size: 12px;
    text-decoration: underline;
  }
  .user-op:hover,.exit:hover  {
    color: #409EFF;
  }
  .exit {
    font-size: 12px;
    text-decoration: underline;
    margin-left: 10px;
  }
  .user-operate {
    position: absolute;
    background: #ffffff;
    z-index: 9;
    color: #444;
    width: 120px;
    text-align: center;
    box-shadow: 1px 2px 15px rgba(0, 0, 0, .3);
    top: 90px;
    right: 0;
    font-size: 16px;
  }
  .op-item {
    line-height: 30px;
  }
  .op-item:hover {
    background: #e6e6e6;
    color: #409EFF;
  }
  .user-icon {
    /*width: 20px;*/
    /*line-height: 18px;*/
    /*height: 20px;*/
    /*display: table-cell;*/
    /*border-radius: 50%;*/
    /*background: #409EFF;*/
    /*border: 1px solid #fff;*/
    position: relative;
    top: 18px;
  }
  .matched-cur-page::before {
    position: absolute;
    content: '';
    height: 6px;
    width: 100%;
    background: #ffffff;
    left: 0;
    bottom: 0;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserInfo/UserInfo.vue